import { RichTextInput } from "ra-input-rich-text";
import {
  DeleteWithConfirmButton,
  Edit,
  SimpleForm,
  ImageInput,
  ImageField,
  NumberField,
  ArrayInput,
  SimpleFormIterator,
  SelectInput,
  TabbedForm,
  FormTab,
  BooleanInput,
  PasswordInput,
  required,
  TextField,
  FileField,
  TextInput,
  Toolbar,
  TopToolbar,
  SimpleShowLayout,
  WithRecord,
  ListButton,
  ReferenceField,
  ReferenceInput,
  useRecordContext,
  Labeled,
  SaveButton,
  ShowButton,
  FunctionField,
} from "react-admin";
import { CreateTag } from "../components/CreateTag";
import { CustomRichTextEditor } from "../erpd";

const Title = ({ record }) => {
  if (!record) return null;
  return <span>User: {record.name}</span>;
};

function EditToolbar() {
  const record = useRecordContext();

  return <Toolbar sx={{flex: 1, display: 'flex', justifyContent: 'space-between'}}>
    <SaveButton />
    <DeleteWithConfirmButton
      redirect={`/projects/${record.project_id}/show/drawings`}
      confirmColor="warning"
      translateOptions={{ name: record.title }}
    />
  </Toolbar>;
};

const EditLayout = (props) => {
  const record = useRecordContext(props);
  return (
    <>
      {" "}
      <SimpleShowLayout>
        <ReferenceField source="project_id" reference="projects" link="show">
          <WithRecord render={(record) => record.name} />
        </ReferenceField>
        <FunctionField
          label="File"
          render={(record) => (
            <a
              title={`${window.location.protocol}//${window.location.host}/${process.env.PUBLIC_URL}uploads/render/${record["file_id"]}`}
            >
              {record.upload.originalname} ({record.upload.size}B)
            </a>
          )}
        />
      </SimpleShowLayout>
      <SimpleForm toolbar={<EditToolbar />} >
        <ReferenceInput
          label="Drawing Type"
          source="drawingType._id"
          reference="drawing_types"
          filter={{ project_id: record.project_id }}
        >
          <SelectInput
            optionValue="id"
            optionText="name"
            validate={required()}
            create={<CreateTag resource="drawing_types" />}
            createLabel="(Create...)"
          ></SelectInput>
        </ReferenceInput>

        <TextInput source="version" label="Revision" />

        <ReferenceInput
          label="Drawing Status"
          source="drawingStatus._id"
          reference="drawing_statuses"
          filter={{ project_id: record.project_id }}
        >
          <SelectInput
            optionValue="id"
            optionText="name"
            validate={required()}
            create={<CreateTag resource="drawing_statuses" />}
            createLabel="(Create...)"
          ></SelectInput>
        </ReferenceInput>

        <CustomRichTextEditor source="remarks" fullWidth />
      </SimpleForm>
    </>
  );
};

export const DrawingEdit = () => {
  function makeChoices(array) {
    return array.map((x) => ({ id: x.name, name: x.name }));
  }

  return (
    <Edit
      mutationMode="pessimistic"
      redirect="show"
      actions={
        <TopToolbar style={{ minHeight: 20 }}>
          <WithRecord
            render={(record) => (
              <ListButton to={`/projects/${record.project_id}/show/drawings`} />
            )}
          />
          <ShowButton />
        </TopToolbar>
      }
    >
      <EditLayout />
    </Edit>
  );
};
